module.exports = __webpack_public_path__ + "static/media/ubuntu.4c21274b.svg";